import { defineComponent as _defineComponent } from 'vue'
import { ref, useContext, nextTick } from '@nuxtjs/composition-api';
import PublicPortfolioEditPersonalInfoModalForm from './PublicPortfolioEditPersonalInfoModalForm.vue';
import JobsEditModal from '@/components/partials/jobs/JobsEditModal.vue';
import type { InquiryAndUserInput } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

type PublicPortfolioEditPersonalInfoModalFormEmits = {
  (event: 'upsert', payload: InquiryAndUserInput & { modalName: string }): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioEditPersonalInfoModal',
  emits: ["upsert"],
  setup(__props, { emit }: { emit: ({
  (event: 'upsert', payload: InquiryAndUserInput & { modalName: string }): void;
}), expose: any, slots: any, attrs: any }) {



const { $constants } = useContext();

const form = ref<PublicPortfolioEditPersonalInfoModalForm | null>(null);

function handleSave() {
  form.value?.save();
}

function handleUpsert(payload: InquiryAndUserInput) {
  emit('upsert', { ...payload, modalName: $constants.dynamicModals.PORTFOLIO_EDIT_PERSONAL_INFO_MODAL });
}

function handleModalOpen() {
  nextTick(() => {
    form.value?.generateForm();
  });
}

return { __sfc: true,emit, $constants, form, handleSave, handleUpsert, handleModalOpen, PublicPortfolioEditPersonalInfoModalForm, JobsEditModal }
}

})